/// <amd-module name="Wit/WorkItemLinksRegistration/Constants" />

/*
 * Re-exported for convenience
 */
export {RegisteredLinkTypeNames} from "Wit/WorkItemModel/OM";

export const ToolIds = {
    VersionControl: "VersionControl",
    WorkItemTracking: "WorkItemTracking",
    RemoteWorkItemTracking: "RemoteWorkItemTracking",
    TeamBuild: "Build",
    TestManagement: "TestManagement",
    Requirements: "Requirements",
    Hyperlink: "Hyperlink",
    Legacy: "Legacy",
    CodeSense: "CodeSense",
    Git: "Git",
    CodeReview: "CodeReview",
    ProjectDownload: "ProjectDownload",
    Wiki: "Wiki",
    GitHub: "GitHub",
    ReleaseManagement: "ReleaseManagement"
} as const;

export const ArtifactTypeNames = {
    TcmResult: "TcmResult",
    TcmResultAttachment: "TcmResultAttachment",
    TcmTest: "TcmTest",
    Build: "Build",
    VersionedItem: "VersionedItem",
    LatestItemVersion: "LatestItemVersion",
    Changeset: "Changeset",
    Shelveset: "Shelveset",
    WorkItem: "WorkItem",
    Storyboard: "Storyboard",
    Commit: "Commit",
    CodeReviewId: "CodeReviewId",
    CodeReviewSdkId: "ReviewId",
    PullRequestId: "PullRequestId",
    ProjectDownloadProject: "Project",
    Ref: "Ref",
    WikiPage: "WikiPage",
    PullRequest: "PullRequest",
    Issue: "Issue"
} as const;

export const LinkTypeFieldIds = {
    Attachment: 50, // AttachedFiles,
    Hyperlink: 51, // LinkedFiles
    ExternalLink: 58, // BISURI
    WorkItem: 37 // RelatedLinks
};